import React from "react";
import { UnifiedShortOrderFormContainer } from "client/components/UnifiedShortOrderForm/UnifiedShortOrderFormContainer";

const UnifiedShortOrderFormScene = () => <UnifiedShortOrderFormContainer />;

export default UnifiedShortOrderFormScene;
